// extracted by mini-css-extract-plugin
export var heading = "heading-module--heading--85416";
export var heading1 = "heading-module--heading1--df441 heading-module--heading--85416";
export var heading2 = "heading-module--heading2--ff962 heading-module--heading--85416";
export var heading3 = "heading-module--heading3--ff197 heading-module--heading--85416";